// src/components/TeamItemsPage/TeamItemCardSkeleton.jsx

import React from 'react';
import styles from './TeamItemCardSkeleton.module.css';

const TeamItemCardSkeleton = () => {
  return (
    <div className={styles.skeletonCard}>
      {/* Priority Indicator */}
      <div className={styles.priorityBar}></div>
      
      {/* Card Content */}
      <div className={styles.cardContent}>
        {/* Header Row */}
        <div className={styles.headerRow}>
          <div className={styles.priorityBadge}></div>
          <div className={styles.titleSkeleton}></div>
          <div className={styles.actionsSkeleton}>
            <div className={styles.actionBtn}></div>
            <div className={styles.actionBtn}></div>
            <div className={styles.actionBtn}></div>
          </div>
        </div>

        {/* Description */}
        <div className={styles.descriptionSkeleton}>
          <div className={styles.descLine}></div>
          <div className={styles.descLineShort}></div>
        </div>

        {/* Meta Row */}
        <div className={styles.metaRow}>
          <div className={styles.metaItem}></div>
          <div className={styles.metaItem}></div>
          <div className={styles.metaItem}></div>
          <div className={styles.metaItem}></div>
        </div>

        {/* Progress Bar */}
        <div className={styles.progressSection}>
          <div className={styles.progressBar}></div>
          <div className={styles.progressText}></div>
        </div>

        {/* Footer */}
        <div className={styles.footerRow}>
          <div className={styles.tagsSkeleton}>
            <div className={styles.tag}></div>
            <div className={styles.tag}></div>
          </div>
          <div className={styles.completeBtn}></div>
        </div>
      </div>
    </div>
  );
};

export default TeamItemCardSkeleton;

